import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { publicRoutes, protectedRoutes } from './routes.config';
import Layout from '../Components/Layout/Layout';
import Navbar from '../Components/navbar/Navbar';


const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/create-dashboard");
  }, []);

  return null;
};

const AppRoutes: React.FC = () => {
  return (
    <>
      <Layout>
        <Navbar />
      </Layout>
      <Routes>

      <Route
            path={"/"}
            element={<HomePage/>}
          />
        {publicRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={route.element}
          />
        ))}
        {protectedRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={route.element}
          />
        ))}
      </Routes>
    </>
  );
};

export default AppRoutes;
